export const CALENDLY_URL = "https://calendly.com/teccexec";

export const HERO_BG = "/hero-zen.jpg";

export const BOARDROOM_BG =
  "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxleGVjdXRpdmUlMjBib2FyZHJvb20lMjBkYXJrfGVufDB8fHx8MTc4Nzc3NTE4NHww&ixlib=rb-4.1.0&q=85";

export const SERVER_BG =
  "https://images.pexels.com/photos/37730211/pexels-photo-37730211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
